import { FC } from 'react';

import {
    DataGrid,
    DataGridProps as MuiDataGridProps,
} from '@thirdspacelearning/library';

const sx = {
    dataGrid: {
        width: '100%',
        '& .MuiDataGrid-row': {
            ':nth-of-type(odd)': {
                backgroundColor: 'background.default',
            },
        },
        '& .MuiDataGrid-columnHeaderTitle': {
            textOverflow: 'clip',
            whiteSpace: 'break-spaces',
            lineHeight: 1.5,
        },
        '& .MuiDataGrid-cell': {
            position: 'relative',
            py: 1,
            display: 'flex',
            alignItems: 'center',
            overflow: 'visible',

            whiteSpace: 'normal',
            wordBreak: 'break-word',
            lineHeight: '1.4rem',

            minHeight: '50px',

            '&::after': {
                content: '""',
                position: 'absolute',
                top: '20%',
                bottom: '20%',
                right: 0,
                width: '1px',
                backgroundColor: 'divider',
            },
        },
        '& .MuiDataGrid-cell:is(:last-of-type, :nth-last-of-type(2))::after': {
            display: 'none',
        },
    },
};

const CMSDataGrid: FC<MuiDataGridProps> = ({ ...rest }) => {
    return (
        <DataGrid
            getRowHeight={() => 'auto'}
            density="comfortable"
            sx={sx.dataGrid}
            {...rest}
        />
    );
};

export default CMSDataGrid;
